<template>
  <div
    class="d-flex align-center justify-center"
    style="height: 100vh"
  >
    <v-row
      :align="'center'"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card
          class="pa-3 pa-md-5 mx-auto"
          light
        >
          <v-card-title class="text-center text-h2">
            Login De Demonstração
          </v-card-title>
          <v-card-text>
            <v-form
              v-model="valid"
              @submit.prevent="login"
            >
              <v-text-field
                v-model="codigoAtivacao"
                label="Código de demonstração"
                required
              />
              <v-btn
                class="v-btn--block"
                color="success"
                default
                min-width="180"
                type="submit"
              >
                Confirmar
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import UsuarioProdutor from '../../services/usuarioprodutor'
  export default {
    data () {
      return {
        codigoAtivacao: '',
        valid: false,
        produtor: {
          id: '',
          chaveativacao: '',
          nome: '',
          email: '',
          cpf: '',
          telefone: '',
          datanascimento: '',
          codigoativacao: '',
          platform: '',
          osname: 'unknown',
          token: '',
          codigoDemo: '',
        },
      }
    },
    methods: {
      login () {
        if (this.codigoAtivacao === '') {
          alert('Preencha o codigo de demonstração e tente novamente!')
        } else {
          UsuarioProdutor.loginDemo(this.codigoAtivacao)
            .then(resposta => {
              this.produtor = resposta.data.usuarioprodutor
              if (this.codigoAtivacao === this.produtor[0].codigodemo) {
                this.salvar()
              } else {
                alert('Código de demonstração inválido')
              }
            })
            .catch(error => {
              console.error('Erro na requisição ao servidor:', error.data)
              if (error.data.ativo === false) {
                alert('Usuario não encontrado ou inativo')
              } else {
                alert('Erro desconhecido')
              }
            })
        }
      },

      salvar () {
        this.exibeProgress = true
        this.msgEnvio = ''
        this.produtor[0].osname = localStorage.osname
        if (localStorage.token && localStorage.token !== '') {
          this.produtor.token = localStorage.token
        }
        if (localStorage.platform && localStorage.platform !== '') {
          this.produtor.platform = localStorage.platform
        } else {
          this.produtor.platform = 'unknown'
        }
        // console.log(this.produtor.platform)
        this.loading = true

        this.errors = ''
        // this.codigoativacaotemp = resposta.data.codigoativacao
        this.cadastrook = true
        localStorage.chaveativacao = this.produtor[0].chaveativacao
        this.salvaDadosOffline()
        this.loading = false
        this.carregaMsgEnvio()
        this.cadastrook = true
        localStorage.setItem('cadastrook', true)
        localStorage.setItem('chaveativacao', this.produtor[0].chaveativacao)

        if (this.produtor[0].status === 'ativo') {
          this.$router.push('/')
          localStorage.countDownViewMenu = 0
        } else {
          alert('Usuario inativo!!')
        }
      },
      salvaDadosOffline () {
        // Dados do Produtor =========================================v
        localStorage.nome = this.produtor[0].nome
        localStorage.cpf = this.produtor[0].cpf
        localStorage.telefone = this.produtor[0].telefone
        localStorage.email = this.produtor[0].email
        localStorage.datanascimento = this.produtor[0].datanascimento
      // Dados do Produtor =========================================^
      },
      carregaMsgEnvio () {
        if (localStorage.telefone) {
          this.produtor.telefone = localStorage.telefone
        }
        if (localStorage.email && localStorage.email.length > 0) {
          this.produtor.email = localStorage.email
        }
      },
    },
  }
  </script>

  <style lang="sass">
  #login
    .v-list-item__subtitle
      -webkit-line-clamp: initial
      -webkit-box-orient: initial
  </style>
